import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContentCacheUtils } from 'src/utils/storage.util';

@Component({
  selector: 'app-ecommerce-market-selector',
  imports: [],
  templateUrl: './ecommerce-market-selector.component.html',
  styleUrl: './ecommerce-market-selector.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EcommerceMarketSelectorComponent {
  markets = ContentCacheUtils.markets()
  market = ContentCacheUtils.market()

}
